import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import { shallowEqual } from '../utils';
import CheckboxGroupContext from './CheckboxGroupContext';

var CheckboxGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CheckboxGroup, _Component);

  function CheckboxGroup(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _event$target = event.target,
          checked = _event$target.checked,
          value = _event$target.value;
      var newValue = [].concat(_this.props.value);

      if (checked) {
        newValue.push(value);
      } else {
        newValue.splice(newValue.indexOf(value), 1);
      }

      _this.props.onChange(newValue);
    });

    _this.state = {
      name: props.name,
      value: props.value,
      onChange: _this.handleChange
    };
    return _this;
  }

  var _proto = CheckboxGroup.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (!shallowEqual(lastProps.value, this.props.value)) {
      this.setState({
        value: this.props.value
      });
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
      value: this.state
    }, this.props.children);
  };

  return CheckboxGroup;
}(Component);

export default CheckboxGroup;